import { useState } from "react";
import styled from "styled-components";
import { Video } from "../models/post";
import Modal from "../components/modal";
import TextInput from "../components/text-input";
import PrimaryButton from "../components/primary-button";
import { DeleteButton } from "./text-component";
import { AddRounded, CloseRounded } from "@mui/icons-material";
const VideoWrapper = styled.div`
  position: relative;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  overflow: hidden;
`;

const Placeholder = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5rem;
  color: #CCCCCC;
  cursor: pointer;
  transition: .1s;
  &:hover {
    color: #BBBBBB;
  }
`;
const PlaceholderContainer = styled.div`
	position: relative;
	padding-bottom: 56.25%;
`;
const Container = styled.div`
	position: relative;
	padding-bottom: 56.25%;
	&:hover {
		&::after {
			opacity: 1;
		}
	}
	&::after {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		content: 'URL ändern';
		color: white;
		font-weight: bold;
		font-size: 2rem;
		text-shadow: 0 2px 10px rgba(0,0,0, 0.8);
		opacity: 0;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		transition: .1s;
		cursor: pointer;
		background: rgba(0,0,0, 0.3);
	}
	iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function ChangeSourceModal(props: {
	close: () => void;
	source: string;
	updateSource: (src: string) => void;
}) {
	const [src, setSrc] = useState(props.source);
	return <Modal title="Quelle ändern" close={props.close}>
		<TextInput value={src} onChange={e => setSrc(e.target.value)} placeholder="Embed-URL" />
		<PrimaryButton onClick={() => {
			props.updateSource(src);
			props.close();
		}}>
			Änderung übernehmen
		</PrimaryButton>
	</Modal>
}

export function VideoComponent(props: {
	video: Video;
	update: (src: string) => void;
	deleteContent: () => void;
}) {
	const [src, setSrc] = useState(props.video.src);
	const [showModal, setShowModal] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	return <>
		<VideoWrapper onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)}>
			<DeleteButton show={showDelete} onClick={props.deleteContent}>
				<CloseRounded />
			</DeleteButton>
			{src === "" ? <PlaceholderContainer onClick={() => setShowModal(true)}>
				<Placeholder>
					<AddRounded />
				</Placeholder>
			</PlaceholderContainer> : <Container onClick={() => setShowModal(true)}>
				<iframe title="video" loading="lazy" src={src} frameBorder="0" allow="accelerometer; encrypted-media; gyroscope;"></iframe>
			</Container>}
		</VideoWrapper>
		{showModal && <ChangeSourceModal close={() => setShowModal(false)} source={src} updateSource={src => setSrc(src)} />}
	</>;
}
